import React from 'react'

import useStyles from './styles'

const NoNotification: React.FC = () => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <svg
          width='200'
          height='200'
          viewBox='0 0 200 200'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className={classes.icon}
        >
          <circle cx='100' cy='100' r='100' fill='#F5F6F8' />
          <path
            d='M131.92 104.904L126.616 98.816C125.486 97.4497 124.2 94.7149 123.903 93.0325L122.073 82.651C120.373 73.0081 113.241 65.6767 104.388 63.2183C101.589 59.8195 97.237 58.1752 92.7233 58.971C88.2506 59.7597 84.6562 62.8897 83.1953 67.0821C75.8956 72.4733 71.8104 81.6978 73.489 91.2176L75.3195 101.599C75.6162 103.282 75.343 106.291 74.7418 107.92L71.8057 115.504C70.6491 118.543 70.8152 121.644 72.333 124.254C73.8026 126.829 76.5178 128.551 79.7351 129.041C88.1732 130.345 96.7756 130.183 105.146 128.707C113.517 127.231 121.657 124.441 129.147 120.371C131.853 118.92 133.685 116.355 134.253 113.335C134.82 110.316 133.983 107.248 131.92 104.904Z'
            fill='#8F8F8F'
          />
          <path
            d='M117.408 130.82C116.524 135.884 112.57 140.093 107.235 141.034C103.994 141.605 100.562 140.856 97.8923 138.915C96.3621 137.916 95.0879 136.448 94.2168 134.867C94.7647 134.855 95.3054 134.802 95.8943 134.783C96.8598 134.74 97.8663 134.689 98.8656 134.597C101.241 134.39 103.642 134.094 106.022 133.674C108.361 133.262 110.678 132.726 112.94 132.116C113.787 131.882 114.642 131.689 115.441 131.421C116.083 131.223 116.725 131.025 117.408 130.82Z'
            fill='#8F8F8F'
          />
        </svg>

        <div className={classes.title}>No Notifications Yet</div>

        <div className={classes.subtitle}>
          We’ll let you know when we get news for you.
        </div>
      </div>
    </div>
  )
}

export default NoNotification
